import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { StepContext } from '../ui/classic/multi-step-modal/component';

export enum ADD_SPOTS_OPTION {
  SINGLE = 'single',
  BULK = 'bulk',
}

interface AddParkingOptionsArgs {
  stepContext: StepContext;
  setAddParkingOption: (key: string) => void;
  onContinue: () => void;
  onClose: () => void;
}

export default class AddParkingOptionsComponent extends Component<AddParkingOptionsArgs> {
  get options(): { key: ADD_SPOTS_OPTION; label: string; description: string; image: string }[] {
    return [
      {
        key: ADD_SPOTS_OPTION.SINGLE,
        label: 'Add one at a time',
        description: 'Recommended for parking spots with unique names',
        image: 'resource-create-single.svg',
      },
      {
        key: ADD_SPOTS_OPTION.BULK,
        label: 'Add in bulk',
        description: 'Recommended to quickly create multiple parking spots',
        image: 'resource-list.svg',
      },
    ];
  }

  @action
  handleSelect(option: ADD_SPOTS_OPTION): void {
    // Set the selection and immediately navigate to the next step
    this.args.setAddParkingOption(option);
    this.args.onContinue();
  }
}
